class DeviceWebModel {
  constructor({
    brand = null,
    browser = null,
    browser_version = null,
    device_type = null,
    engine = null,
    engine_version = null,
    model = null,
    operating_system = null,
    operating_system_version = null,
    screen_height = null,
    screen_width = null,
    supported_architectures = null,
    timezone_offset_sec = null,
  } = {}) {
    this.brand = brand;
    this.browser = browser;
    this.browser_version = browser_version;
    this.device_type = device_type;
    this.engine = engine;
    this.engine_version = engine_version;
    this.model = model;
    this.operating_system = operating_system;
    this.operating_system_version = operating_system_version;
    this.screen_height = screen_height;
    this.screen_width = screen_width;
    this.supported_architectures = supported_architectures;
    this.timezone_offset_sec = timezone_offset_sec;
  }

  json() {
    return {
      brand: this.brand,
      browser: this.browser,
      browser_version: this.browser_version,
      device_type: this.device_type,
      engine: this.engine,
      engine_version: this.engine_version,
      model: this.model,
      operating_system: this.operating_system,
      operating_system_version: this.operating_system_version,
      screen_height: this.screen_height,
      screen_width: this.screen_width,
      supported_architectures: this.supported_architectures,
      timezone_offset_sec: this.timezone_offset_sec,
    };
  }
}

module.exports = DeviceWebModel;
